import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import TrackingNumberColumn from '../../../components/columns/tracking-number-column';

import style from './style.module.less';

import { messages } from '../messages';

const Tracking = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  if (!fulfillment?.trackingInformation) {
    return '';
  }

  const { isVoided } = fulfillment?.externalFulfillment ?? {};

  return (
    <div className={classNames({ [style['voided-tracking-number']]: isVoided })}>
      <TrackingNumberColumn shouldRenderIcon={!isVoided} trackingSummary={fulfillment?.trackingInformation} />
    </div>
  );
};

Tracking.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const tracking = {
  getMessageDescriptor: () => messages.trackingNumber,
  name: <FormattedMessage {...messages.trackingNumber} />,
  id: 'tracking',
  render: (data) => <Tracking fulfillmentId={data.id} />,
};
